import { set, map, findIndex, omit } from 'lodash'
import { http, queryString } from 'utils'
import { ADD_USERSTORY, ADD_USERSTORY_AT_INDEX, REMOVE_USERSTORY, SET_USERSTORIES, SET_USERSTORY_PROPERTY, SET_EPICS, SET_EPIC_PROPERTY, ADD_EPIC, REMOVE_EPIC, SET_TAG } from 'vx/mutations'

// User state.
const state = {
  epics: []
}

// User state getters.
const getters = {}

// User actions.
const actions = {
  addEpic({ commit }, { id, payload }) {
    return http.post(`/user-story-document/${id}/epics`, payload).then(response => {
      commit(ADD_EPIC, response.data)

      return response
    })
  },

  updateEpic({ commit }, { docId, epicId, payload }) {
    return http.put(`/user-story-document/${docId}/epics/${epicId}`, payload).then(response => {
      commit(ADD_EPIC, response.data)
    })
  },

  deleteEpic({ commit }, { docId, epicId }) {
    return http.delete(`/user-story-document/${docId}/epics/${epicId}`).then(response => {
      commit(REMOVE_EPIC, epicId)

      return response
    })
  },

  reorderEpics({ commit }, { id, payload }) {
    return http.put(`/user-story-document/${id}/epics/order`, payload).then(response => {

      return response
    })
  },

  setEpics({ commit }, epics) {
    commit(SET_EPICS, epics)
  },

  setEpicProperty({ commit }, { property, value }) {
    commit(SET_EPIC_PROPERTY, { property, value })
  },

  addUserStory({ commit }, { id, index, payload }) {
    return http.post(`/user-story-document/${id}/stories`, payload).then(response => {
      
      if (index) {

        commit(ADD_USERSTORY_AT_INDEX, { index: index, userstory: response.data })
      } else {
        
        commit(ADD_USERSTORY, response.data)
      }

      return response
    })
  },

  updateUserStory({ commit }, { docId, storyId, payload, refresh=true }) {
    return http.put(`/user-story-document/${docId}/stories/${storyId}`, payload).then(response => {
      if (refresh) commit(ADD_USERSTORY, response.data)
    })
  },

  deleteUserStory({ commit }, { docId, userstory }) {
    return http.delete(`/user-story-document/${docId}/stories/${userstory.id}`).then(response => {
      commit(REMOVE_USERSTORY, userstory)

      return response
    })
  },

  reorderUserStories({ commit }, { id, payload }) {
    return http.put(`/epics/${id}/stories/order`, payload).then(response => {

      return response
    })
  },

  setUserStoryProperty({ commit }, { property, value }) {
    commit(SET_USERSTORY_PROPERTY, { property, value })
  },

  setUserStories({ commit }, { epicId, userstories }) {
    commit(SET_USERSTORIES, { epicId, userstories })
  },

  setTag({commit}, {epic, tag}) {
    commit(SET_TAG, {epic, tag})
  }
}

// User state mutations.
const mutations = {

  /**
  * Set the project state.
  */
  [SET_EPICS] (state, epics) {
    state.epics = epics
  },

  [ADD_EPIC] (state, epic) {
    let epicIndex = findIndex(state.epics, existing => existing.id === epic.id)

    if (epicIndex === -1) {
      state.epics.push(epic)
    } else {
      state.epics.splice(epicIndex, 1, epic)
    }
  },

  [REMOVE_EPIC] (state, id) {
    let existingItem = findIndex(state.epics, existing => existing.id === id)

    if (existingItem >= 0) {
      state.epics.splice(existingItem, 1)
    }
  },

  [SET_EPIC_PROPERTY] (state, { property, value }) {
    set(state, property, value)
  },

  [ADD_USERSTORY] (state, userstory) {
    let epic = findIndex(state.epics, existing => existing.id === userstory.epic_id)

    if (epic !== -1) {
      let story = findIndex(state.epics[epic].stories, existing => existing.id === userstory.id)

      if (story === -1) {
        state.epics[epic].stories.push(userstory)
      } else {

        state.epics[epic].stories.splice(story, 1, userstory)
      }
    }
  },

  [SET_USERSTORIES] (state, { epicId, userstories }) {
    let epic = findIndex(state.epics, existing => existing.id === epicId)

    if (epic !== -1) {
      state.epics[epic].stories = userstories
    }
  },
  
  [ADD_USERSTORY_AT_INDEX] (state, { index, userstory }) {
    let epic = findIndex(state.epics, existing => existing.id === userstory.epic_id)

    if (epic !== -1) {
      state.epics[epic].stories.splice(index, 0, userstory)
    }
  },

  [REMOVE_USERSTORY] (state, userstory) {
    let epic = findIndex(state.epics, existing => existing.id === userstory.epic_id)

    if (epic !== -1) {
      let existingItem = findIndex(state.epics[epic].stories, existing => existing.id === userstory.id)

      if (existingItem >= 0) {
        state.epics[epic].stories.splice(existingItem, 1)
      }
    }
  },

  [SET_USERSTORY_PROPERTY] (state, { property, value }) {
    set(state, property, value)
  },
  [SET_TAG] (state, {epic, tag}) {
    let epicIndex = findIndex(state.epics, existing => existing.id === epic.id)
    state.epics[epicIndex].tags.splice(0,1,tag)
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
